module.exports = "/logo_gfw.svg?1cc95c";